import { ConfigFilterItem } from 'Core/interfaces'

export enum LocationByPeriodFilterFields {
	serviceSiteId = 'serviceSiteId',
	kpiCategoryId = 'kpiCategoryId',
	kpiId = 'kpiId',
	year = 'year'
}

export enum TermTableFormFields {
	index = 'index',
	rowKey = 'rowKey',
	backendId = 'backendId',
	kpiId = 'kpiId',
	serviceSiteId = 'serviceSiteId',
	year = 'year',
	term = 'term',
	termToDisplay = 'termToDisplay',
	value = 'value',
	uomCode = 'uomCode',
	terms = 'terms',
	createdBy = 'createdBy'
}

export declare namespace LocationByPeriods {
	type SelectsConfig = {
		uom?: {
			options: LabelValue[]
			placeholder: string
		}
		kpi?: {
			options: LabelValue[]
			placeholder: string
		}
	}

	interface TermFormValue {
		[TermTableFormFields.index]: number
		[TermTableFormFields.rowKey]: string
		[TermTableFormFields.backendId]?: number
		[TermTableFormFields.kpiId]: number
		[TermTableFormFields.serviceSiteId]: number
		[TermTableFormFields.year]: number
		[TermTableFormFields.term]: string
		[TermTableFormFields.termToDisplay]: string
		[TermTableFormFields.value]: string | number | LabelValue | null | boolean
		[TermTableFormFields.uomCode]: string | LabelValue | null
		[TermTableFormFields.createdBy]: BasicString
	}
	interface FieldArray {
		terms: {
			[TermTableFormFields.index]: number
			[TermTableFormFields.rowKey]: string
			[TermTableFormFields.backendId]?: number
			[TermTableFormFields.kpiId]: number
			[TermTableFormFields.serviceSiteId]: number
			[TermTableFormFields.year]: number
			[TermTableFormFields.term]: string
			[TermTableFormFields.termToDisplay]: string
			[TermTableFormFields.value]: string | number | LabelValue | null
			[TermTableFormFields.uomCode]: string | LabelValue | null
			[TermTableFormFields.createdBy]: BasicString
		}[]
	}

	type FieldType = Record<TermTableFormFields, null | Key | boolean | LabelValue | LabelValue[]>
	namespace Filter {
		interface Config {
			[LocationByPeriodFilterFields.serviceSiteId]: ConfigFilterItem<string, null>
			[LocationByPeriodFilterFields.kpiCategoryId]: ConfigFilterItem<string, null>
			[LocationByPeriodFilterFields.kpiId]: ConfigFilterItem<string, null>
			[LocationByPeriodFilterFields.year]: ConfigFilterItem<string, string>
		}
	}
}
